export const UPDATE_SEARCH_PAGE_RESULTS_VIEW_ACTION = 'UPDATE_SEARCH_PAGE_RESULTS_VIEW';

export const SEARCH_PAGE_RESULTS_VIEW_KEY = 'SEARCH_PAGE_RESULTS_VIEW';
